const contentCarousel = document.querySelector('.content-carousel-splide');

if (contentCarousel) {
  const blockCount = parseInt(contentCarousel.dataset.blockCount);
  const splide = new Splide('.content-carousel-splide', {
    perPage: 4,
    arrows: false,
    pagination: false,
    gap: 30,
    speed: 900,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    updateOnMove: true,
    perMove: 1,
    breakpoints: {
      1439: {
        perPage: 3
      },
      639: {
        perPage: 1,
        padding: {
          right: '40%'
        },
        gap: 20
      }
    }
  });
  splide.mount();

  const contentCarouselLeftArrow = document.querySelector('.content-carouselsplide__arrow--left');
  const contentCarouselRightArrow = document.querySelector('.content-carouselsplide__arrow--right');

  contentCarouselLeftArrow.addEventListener('click', function () {
    splide.go('<');
  });

  contentCarouselRightArrow.addEventListener('click', function () {
    splide.go('>');
  });

  splide.on('move', function() {
    if (splide.index == 0) {
      contentCarouselLeftArrow.classList.add('hide')
    } else {
      contentCarouselLeftArrow.classList.remove('hide')
    }

    let slideCount = 4;
    if (window.innerWidth < 768) {
      slideCount = 1;
    } else if (window.innerWidth < 1440) {
      slideCount = 3;
    }

    if (splide.index + slideCount == blockCount) {
      contentCarouselRightArrow.classList.add('hide');
    } else {
      contentCarouselRightArrow.classList.remove('hide');
    }
  })
}
